import { useMemo } from 'react';
import {
    PortfolioEnterpriseRelationshipFilters,
    PortfolioEnterpriseRelationshipResult,
    PortfolioStringFilter,
} from '@mews-commander/data-access';
import { TableState } from '@optimus-web/core';
import { PricingTableData } from '../types';

export type CurrencyCountryTableState = TableState<
    PortfolioEnterpriseRelationshipResult & { defaultCurrencyCode: string },
    PortfolioEnterpriseRelationshipFilters & { defaultCurrencyCode: Array<PortfolioStringFilter> }
>;
interface Props {
    data: PricingTableData[];
    tableState: CurrencyCountryTableState;
}
export const useProperties = ({ data, tableState }: Props) => {
    const { selectedCountries, selectedCurrencies }: { selectedCountries: string[]; selectedCurrencies: string[] } =
        useMemo(() => {
            const countries = new Set<string>();
            const currencies = new Set<string>();

            data.forEach((item) => {
                countries.add(item.countryName);
                currencies.add(item.defaultCurrencyCode);
            });

            return {
                selectedCountries: Array.from(countries),
                selectedCurrencies: Array.from(currencies),
            };
        }, [data]);

    const filteredData = useMemo(() => {
        const countryFilter = tableState.filters?.countryName;
        const currencyFilter = tableState.filters?.defaultCurrencyCode;

        if (!countryFilter?.length && !currencyFilter?.length) {
            return data;
        }

        return data.filter((row) => {
            const matchesCountry = !countryFilter?.length || countryFilter[0].value.includes(row.countryName);
            const matchesCurrency =
                !currencyFilter?.length || currencyFilter[0].value.includes(row.defaultCurrencyCode);

            return matchesCountry && matchesCurrency;
        });
    }, [data, tableState.filters?.countryName, tableState.filters?.defaultCurrencyCode]);

    return {
        filteredData,
        selectedCurrencies,
        selectedCountries,
    };
};
